import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H6v16h16V2zm-9.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14zM4 6H2v16h16v-2H4V6z"
}), 'LibraryAddCheckSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LibraryAddCheckSharp.js
// module id = 4459
// module chunks = 2